export default "__VITE_ASSET__BGFSKDme__"